import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import loadingBarImage from '../../../images/loadingBar.gif';
import loadingSpinnerImage from '../../../images/loadingSpinner.gif';

import './Loading.less';


export class Loading extends Component {
  render() {
    const isSpinner = this.props.type === 'spinner';

    const show = this.props.show || this.props.showOverride;

    return show && (
      <div className={isSpinner ? 'spinner' : 'loading_bar'}>
        <img src={isSpinner ? loadingSpinnerImage : loadingBarImage} />
      </div>
    );
  }
}

// todo refactor this showoverride out.
Loading.defaultProps = {
  type: 'bar',
  showOverride: false,
};

Loading.propTypes = {
  type: PropTypes.string,
  showOverride: PropTypes.bool,
};

// todo use new pattern of status: loading to accomplish this.  remove a reducer for global status
function mapStateToProps(state) {
  return { show: state.get('loadingSpinner') };
}

export default connect(mapStateToProps)(Loading);



// WEBPACK FOOTER //
// ./src/components/common/Loading/Loading.js